const $ = jQuery.noConflict();

'use strict';
const Header = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$body: $('body'),
	$domHeader: $('.site-header'),
	$domSearchIcon: $('.js-site-header__search-icon'),
	$domSearchIconClose: $('.js-site-header__search-icon-close'),
	$domSearchInput: $('.js-site-header__search-form'),
	classHeaderScroll: 'is-sticky',

	/** @description Initialize */
	init: function() {
		this.headerScroll();
		this.headerStickyOnLoad();
		this.iconClickShowSearch();
		$('.site-header__search-dropdown-result-btn').on('click', function() {
			$('.site-header__search-dropdown-result-btn').addClass('is-clicked');
		});
		this.megaMenuOpen();

		if(window.innerWidth > 1199) {
			document.querySelectorAll('.menu-item--spec .menu-item-has-children').forEach(function(menuItem) {
				const subMenu = menuItem.querySelector('ul.sub-menu');
				if (subMenu) {
					subMenu.style.position = 'fixed';
				}
				menuItem.addEventListener('mouseenter', function() {
					const subMenu = menuItem.querySelector('ul.sub-menu');
					if (subMenu) {
						const parentRect = menuItem.getBoundingClientRect();
						const subMenuWidth = subMenu.offsetWidth;
						const subMenuHeight = subMenu.offsetHeight;

						if (window.innerWidth - parentRect.right > subMenuWidth) {
							subMenu.style.left = `${parentRect.right + window.scrollX}px`;
						} else {
							subMenu.style.left = `${window.innerWidth - subMenuWidth - 50}px`;
						}

						if (window.innerHeight - parentRect.top > subMenuHeight) {
							subMenu.style.top = `${parentRect.top + window.scrollY}px`;
						} else {
							subMenu.style.top = `${window.innerHeight - subMenuHeight - 50}px`;
						}

						subMenu.style.position = 'fixed';
						subMenu.style.display = 'block';
						subMenu.style.visibility = 'visible';

						subMenu.classList.add('visible-submenu');
						positionNestedSubMenus(subMenu);
					}
				});

				menuItem.addEventListener('mouseleave', function() {
					if (subMenu) {
						subMenu.classList.remove('visible-submenu');
						setTimeout(() => {
							subMenu.scrollTop = 0;
						}, 100);

						setTimeout(() => {
							if (!menuItem.matches(':hover')) {
								subMenu.style.display = 'none';
								subMenu.style.visibility = 'hidden';
							}
						}, 1);
					}
				});
			});
		}

		function positionNestedSubMenus(menu) {
			menu.querySelectorAll('.menu-item--spec .menu-item-has-children ul.sub-menu').forEach(function(nestedSubMenu) {
				nestedSubMenu.style.position = 'fixed';

				nestedSubMenu.parentElement.addEventListener('mouseenter', function() {
					const nestedParentRect = nestedSubMenu.parentElement.getBoundingClientRect();
					const nestedSubMenuWidth = nestedSubMenu.offsetWidth;
					const nestedSubMenuHeight = nestedSubMenu.offsetHeight;

					if (window.innerWidth - nestedParentRect.right > nestedSubMenuWidth) {
						nestedSubMenu.style.left = `${nestedParentRect.right + window.scrollX}px`;
					} else {
						nestedSubMenu.style.left = `${window.innerWidth - nestedSubMenuWidth - 50}px`;
					}

					if (window.innerHeight - nestedParentRect.top > nestedSubMenuHeight) {
						nestedSubMenu.style.top = `${nestedParentRect.top + window.scrollY}px`;
					} else {
						nestedSubMenu.style.top = `${window.innerHeight - nestedSubMenuHeight - 50}px`;
					}

					nestedSubMenu.style.display = 'block';
					nestedSubMenu.style.visibility = 'visible';
				});

				nestedSubMenu.parentElement.addEventListener('mouseleave', function() {
					setTimeout(() => {
						nestedSubMenu.scrollTop = 0;
					}, 100);

					setTimeout(() => {
						if (!nestedSubMenu.parentElement.matches(':hover')) {
							nestedSubMenu.style.display = 'none';
							nestedSubMenu.style.visibility = 'hidden';
						}
					}, 1);
				});

				positionNestedSubMenus(nestedSubMenu);
			});
		}
	},

	headerScroll: function() {
		$(document).on('scroll', function() {
			const scrollTop = $(document).scrollTop();
			if(scrollTop > 20) {
				Header.$domHeader.addClass(Header.classHeaderScroll);
				Header.$body.addClass('is-sticky-header');

			} else {
				Header.$domHeader.removeClass(Header.classHeaderScroll);
				Header.$body.removeClass('is-sticky-header');
			}
		});
	},

	headerStickyOnLoad: function() {
		$(window).on('load', function() {
			const scrollTop = $(document).scrollTop();
			if(scrollTop > 20) {
				Header.$domHeader.addClass(Header.classHeaderScroll);
				Header.$body.addClass('is-sticky-header');
			} else {
				Header.$domHeader.removeClass(Header.classHeaderScroll);
				Header.$body.removeClass('is-sticky-header');
			}
		});
	},

	iconClickShowSearch: function() {
		if ($(window).width() < 751) {
			Header.$domSearchIcon.on('click', function() {
				Header.$domSearchInput.show();
				Header.$domSearchIcon.addClass('hidew');
				Header.$domSearchIcon.removeClass('showw');
				Header.$domSearchIconClose.removeClass('hidew');
				Header.$domSearchIconClose.addClass('showw');
			});
			Header.$domSearchIconClose.on('click', function() {
				Header.$domSearchInput.hide();
				Header.$domSearchIconClose.addClass('hidew');
				Header.$domSearchIconClose.removeClass('showw');
				Header.$domSearchIcon.removeClass('hidew');
				Header.$domSearchIcon.addClass('showw');
				$('.js-display-result').removeClass('is-visible');
				$('.js-search-loader').removeClass('is-visible');
				$('.js-search-close').removeClass('is-visible');
				$('.js-search-form-input').val('');
			});
		}
	},

	megaMenuOpen: function() {
		$('.menu-item--spec a:first').on('click', function() {
			$('.menu-item--spec .sub-menu:first').toggleClass('is-active');
			$('body').toggleClass('prevent-scroll');
		});

		$(document).on('click', function(event) {
			if (!$(event.target).closest('.menu-item--spec').length) {
				$('.menu-item--spec .sub-menu:first').removeClass('is-active');
				setTimeout(() => {
					$('.menu-item--spec .sub-menu:first')[0].scrollTop = 0;
				}, 200);
				$('body').removeClass('prevent-scroll');
			}
		});

		$('.menu-item--spec').on('click', function(event) {
			event.stopPropagation();
		});

		$(document).on('keydown', function(event) {
			if (event.key === 'Escape') {
				$('.menu-item--spec .sub-menu:first').removeClass('is-active');
				setTimeout(() => {
					$('.menu-item--spec .sub-menu:first')[0].scrollTop = 0;
				}, 300);
				$('body').removeClass('prevent-scroll');
			}
		});
	}
};

export default Header;